<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";
import { getS3SingedUrl } from "../../../../api/services/general.service";
import { newFeedbackObject } from "./feedback-controller";
import ImageCroperModel from "../../../../components/models/image-crop";
import {
  getTestimonial,
  updateTestimonial,
} from "../../../../api/services/cms.service";

export default {
  props: {
    visible: Boolean,
    closeable: Boolean,
    feedbackID: String,
  },
  components: {
    "image-cropper-model": ImageCroperModel,
  },
  data() {
    return {
      feedbackId: null,
      name: null,
      designation: null,
      feedback: null,
      feedbackImageURL: null,
      editFeedbackProcessing: false,
      editFeedbackSuccess: false,
      editFeedbackFailed: false,
      showFeedbackImageCropModel: false,
      croppedFeedbackImage: null,
    };
  },
  validations: {
    name: { required },
    designation: { required },
    feedback: { required },
  },
  computed: {
    showModal: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  async mounted() {
    this.feedbackId = this.feedbackID;
    await this.getFeedback(this.feedbackId);
  },
  methods: {
    async getFeedback(feedbackId) {
      let getFeedbackToEdit = await getTestimonial(feedbackId);
      if (getFeedbackToEdit) {
        this.name = getFeedbackToEdit.name;
        this.feedbackImageURL = getFeedbackToEdit.photo;
        this.designation = getFeedbackToEdit.designation;
        this.feedback = getFeedbackToEdit.description;
      }
    },
    async clickSaveFeedbackButton() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.editFeedbackProcessing = true;

        let editFeedbackObject_Pass = new newFeedbackObject();
        editFeedbackObject_Pass.name = this.name;
        editFeedbackObject_Pass.designation = this.designation;
        editFeedbackObject_Pass.feedback = this.feedback;

        if (this.croppedFeedbackImage) {
          const feedbakImageFile = this.$refs.feedbackImageInput.files[0];
          const croppedFeedbackImage = this.croppedFeedbackImage;
          const finalFeedbackImageToPass = await new Promise(function (
            resolve
          ) {
            return croppedFeedbackImage.toBlob(resolve, feedbakImageFile.type);
          });
          const fileName = feedbakImageFile.name;
          let getUploadedImageURL = await getS3SingedUrl(fileName);

          let getFileUploadResponse = await axios.put(
            getUploadedImageURL.signedUrl,
            finalFeedbackImageToPass
          );

          if (getFileUploadResponse) {
            let fileBaseUrl =
              "https://s3.eu-central-1.amazonaws.com/ms-sissi.uploads/";
            editFeedbackObject_Pass.photoURL = fileBaseUrl + fileName;
          }
        }

        let feedbackEditSuccess = await updateTestimonial(
          this.feedbackId,
          editFeedbackObject_Pass
        );

        if (feedbackEditSuccess) {
          this.editFeedbackProcessing = false;
          this.editFeedbackSuccess = true;
          this.$emit("reload");
        } else if (!feedbackEditSuccess) {
          this.editFeedbackProcessing = false;
          this.editFeedbackFailed = true;
        }
      }
    },
    extraImageSelected() {
      const imagePreviewCanvers = this.$refs.feedbackImageCanvas;
      const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
      imagePreviewCanversContext.clearRect(
        0,
        0,
        imagePreviewCanvers.width,
        imagePreviewCanvers.height
      );

      const extraImageFile = this.$refs.feedbackImageInput.files[0];
      this.openCorpExtraImageModel(extraImageFile);
    },
    openCorpExtraImageModel(extraImageFile) {
      this.extraImageFileToCrop = extraImageFile;
      this.showFeedbackImageCropModel = true;
    },
    setCroppedImageToPreview(croppedImage) {
      const imagePreview = this.$refs.extraImagePreview;
      const imagePreviewCanvers = this.$refs.feedbackImageCanvas;
      if (imagePreview && imagePreviewCanvers.getContext) {
        const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
        imagePreviewCanversContext.drawImage(croppedImage, 0, 0, 120, 120);
      }
      this.croppedFeedbackImage = croppedImage;
      this.showFeedbackImageCropModel = false;
    },
    clickRemoveExtraImage() {
      this.croppedFeedbackImage = null;
      this.feedbackImageURL = null;
      const imagePreviewCanvers = this.$refs.feedbackImageCanvas;
      const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
      imagePreviewCanversContext.clearRect(
        0,
        0,
        imagePreviewCanvers.width,
        imagePreviewCanvers.height
      );
    },
  },
};
</script>

<template>
  <!-- Edit Company Model-->
  <b-modal
    v-model="showModal"
    :title="'Feedback erstellen'"
    centered
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    scrollable
  >
    <div class="row">
      <!-- Edit Sucees and Failed Msg -->
      <div class="col-md-12">
        <b-alert v-model="editFeedbackSuccess" variant="success" dismissible
          ><i class="mdi mdi-check-all mr-2"></i
          >{{ $t("CMS.feedback.editSuccessMsg") }}</b-alert
        >
        <b-alert v-model="editFeedbackFailed" variant="danger" dismissible
          ><i class="bx bx-error-circle mr-2"></i
          >{{ $t("CMS.feedback.editFailedMsg") }}</b-alert
        >
        <b-alert v-model="editFeedbackProcessing" variant="info"
          ><i class="bx bx-loader-alt bx-spin mr-2"></i
          >{{ $t("packages.editPackage.editProcessing") }}</b-alert
        >
      </div>
      <!-- Feedback Image -->
      <div class="col-md-3 mb-4">
        <div class="avatar-md mr-4">
          <span ref="extraImagePreview" class="extra-image-preview-after-crop">
            <canvas
              id="feedbackImageCanvas"
              ref="feedbackImageCanvas"
              height="120"
              width="120"
            ></canvas>
            <span
              v-if="!this.croppedFeedbackImage"
              class="avatar-title bg-white"
              style="margin-left: -120px"
            >
              <img
                v-if="this.feedbackImageURL"
                :src="feedbackImageURL"
                class="rounded-0"
                alt
                height="120"
              />
              <img
                v-else
                src="https://s3.eu-central-1.amazonaws.com/ms-sissi.uploads/cms/testimonial-default-img.png"
                class="rounded-0"
                alt
                height="120"
              />
            </span>
          </span>
        </div>
      </div>
      <div class="col-md-9 mb-4">
        <div class="">
          <input
            id="feedbackImageInput"
            ref="feedbackImageInput"
            type="file"
            name="file"
            accept="image/*"
            @change="extraImageSelected()"
            style="width: 0.1px; opacity: 0; z-index: -1"
          />
          <div>
            <label
              for="feedbackImageInput"
              class="text-info ml-3"
              style="cursor: pointer"
            >
              {{ $t("extras.createExtra.form.uploadNewImage") }}
            </label>
            <label class="ml-2" v-if="this.croppedFeedbackImage">
              &#8226;
            </label>
            <label
              class="text-info ml-2"
              @click="clickRemoveExtraImage()"
              style="cursor: pointer"
              v-if="this.croppedFeedbackImage"
            >
              {{ $t("extras.createExtra.form.removeImage") }}
            </label>
          </div>
          <div class="ml-3 text-mute">
            <small>
              {{ $t("extras.createExtra.form.imageSupportText") }}
              <br />
              <b> Bildgröße 500px * 500px </b>
            </small>
          </div>
        </div>
      </div>

      <!-- Feedback Name -->
      <div class="col-md-12 mt-5">
        <div class="mb-4">
          <label>
            Name
            <span class="text-danger">*</span>
            <span class="ml-2">
              <p
                v-if="name"
                class="badge position-absolute"
                :class="{
                  'badge-light': name.length !== 50,
                  'badge-danger': name.length === 50,
                }"
              >
                {{ name.length }} / 50
              </p>
            </span>
          </label>
          <b-form-group>
            <b-form-input
              v-model="name"
              :placeholder="
                this.$i18n.t('extras.createExtra.form.titlePlaceholder')
              "
              :maxlength="50"
              :class="{ 'is-invalid': $v.name.$error }"
            ></b-form-input>
            <div v-if="$v.name.$error" class="invalid-feedback">
              <span v-if="$v.name.$error && !$v.name.required">{{
                $t("extras.createExtra.form.titleRequiredMsg")
              }}</span>
            </div>
          </b-form-group>
        </div>
      </div>
      <!-- Feedback designation -->
      <div class="col-md-12">
        <div class="mb-4">
          <label>
            {{ $t("extras.createExtra.form.titleLabel") }}
            <span class="text-danger">*</span>
            <span class="ml-2">
              <p
                v-if="designation"
                class="badge position-absolute"
                :class="{
                  'badge-light': designation.length !== 50,
                  'badge-danger': designation.length === 50,
                }"
              >
                {{ designation.length }} / 50
              </p>
            </span>
          </label>
          <b-form-group>
            <b-form-input
              v-model="designation"
              :placeholder="
                this.$i18n.t('extras.createExtra.form.titlePlaceholder')
              "
              :maxlength="50"
              :class="{ 'is-invalid': $v.designation.$error }"
            ></b-form-input>
            <div v-if="$v.designation.$error" class="invalid-feedback">
              <span v-if="$v.designation.$error && !$v.designation.required">{{
                $t("extras.createExtra.form.titleRequiredMsg")
              }}</span>
            </div>
          </b-form-group>
        </div>
      </div>
      <!-- Feedback Descrtiption -->
      <div class="col-md-12">
        <div class="mb-4">
          <label>
            {{ $t("extras.createExtra.form.descriptionLabel") }}
            <span class="text-danger">*</span>
            <span class="ml-2">
              <p
                v-if="feedback"
                class="badge position-absolute"
                :class="{
                  'badge-light': feedback.length !== 350,
                  'badge-danger': feedback.length === 350,
                }"
              >
                {{ feedback.length }} / 350
              </p>
            </span>
          </label>
          <textarea
            v-model="feedback"
            class="form-control"
            name="textarea"
            rows="4"
            :maxlength="350"
            :placeholder="
              this.$i18n.t('extras.createExtra.form.descriptionPlaceholder')
            "
            :class="{ 'is-invalid': $v.feedback.$error }"
          ></textarea>
          <div v-if="$v.feedback.$error" class="invalid-feedback">
            <span v-if="$v.feedback.$error && !$v.feedback.required">{{
              $t("extras.createExtra.form.descriptionRequiredMsg")
            }}</span>
          </div>
        </div>
      </div>
      <!-- Save Button -->
      <div class="col-md-12">
        <div class="">
          <b-button variant="success" @click="clickSaveFeedbackButton()">
            <i class="bx bxs-save mr-1"></i>
            {{ $t("general.buttons.save") }}</b-button
          >
        </div>
      </div>
    </div>

    <!-- Image Cropper Model -->
    <image-cropper-model
      v-if="this.showFeedbackImageCropModel === true"
      :visible="showFeedbackImageCropModel"
      @close="showFeedbackImageCropModel = false"
      :imageFile="extraImageFileToCrop"
      @apply="setCroppedImageToPreview"
    />
  </b-modal>
</template>

<style scoped>
.extra-image-preview-after-crop {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: none;
  width: 120px;
  height: 120px;
  padding: 0;
  margin: 0;
}
</style>
